module.exports = __webpack_public_path__ + "img/logo_long.cd5f87a9.png";